module.exports = __webpack_public_path__ + "static/smart-rx-store-874fa04fbcc452541ee5e0866b390c31.png";